<template>
  <!-- Stands in the timeline where the loading older messages will land, so it
       shares their fate rather than sitting on top as chrome. Purely decorative:
       the live region announcement of new content is the messages themselves. -->
  <div class="older-skeleton" aria-hidden="true">
    <span class="sr-only">Loading older messages…</span>
    <div class="older-skeleton__line older-skeleton__line--speaker shimmer" />
    <div class="older-skeleton__line shimmer" />
    <div class="older-skeleton__line shimmer" />
    <div class="older-skeleton__line older-skeleton__line--short shimmer" />
  </div>
</template>

<script setup lang="ts">
// No props — a single calm placeholder block. Multiple messages may load, but a
// single settling shape reads calmer than a faithful count we can't know yet.
</script>

<style scoped>
.older-skeleton {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 0 8px;
}

.older-skeleton__line {
  height: 12px;
  width: 92%;
  border-radius: 5px;
}

.older-skeleton__line--speaker {
  height: 14px;
  width: 32%;
  margin-bottom: 2px;
}

.older-skeleton__line--short {
  width: 58%;
}

.shimmer {
  background: linear-gradient(
    90deg,
    var(--theme-shimmer-from) 0%,
    var(--theme-shimmer-to) 50%,
    var(--theme-shimmer-from) 100%
  );
  background-size: 200% 100%;
  animation: older-skeleton-shimmer 1.6s ease-in-out infinite;
}

@keyframes older-skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* Calm surface: hold a steady tone instead of animating for readers who ask
   for reduced motion. */
@media (prefers-reduced-motion: reduce) {
  .shimmer {
    animation: none;
    background: var(--theme-shimmer-from);
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
